import { supabase } from '../../../lib/supabase';

export interface Invoice {
    id: string;
    stripe_invoice_id: string;
    number: string;
    amount_paid: number;
    currency: string;
    status: string;
    invoice_pdf: string | null;
    hosted_invoice_url: string | null;
    paid_at: string;
    created_at: string;
}

export const getOrganizationInvoices = async (organizationId: string): Promise<Invoice[]> => {
    const { data, error } = await supabase
        .from('invoices')
        .select('*')
        .eq('organization_id', organizationId)
        .order('paid_at', { ascending: false });

    if (error) {
        console.error('Error fetching invoices:', error);
        throw error;
    }
    
    return data || [];
};

/**
 * Busca a fatura mais recente PAGA
 */
export const getLatestPaidInvoice = async (organizationId: string): Promise<Invoice | null> => {
    const { data, error } = await supabase
        .from('invoices')
        .select('*')
        .eq('organization_id', organizationId)
        .eq('status', 'paid')
        .order('paid_at', { ascending: false })
        .limit(1)
        .maybeSingle();

    if (error) {
        console.error('Error fetching latest invoice:', error);
        return null;
    }

    return data;
};
